const StepLine = () => {
  return (
    <div
      className="step-line"
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        height: '7px',
      }}
    >
      <svg
        width={'100%'}
        height={'1'}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1={0}
          y1={0}
          x2={'100%'}
          y2={0}
          stroke="#E0E0E0"
          strokeWidth={2}
        />
      </svg>
      <svg
        width={4}
        height={7}
        viewBox="0 0 4 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1l2 2.5L1 6" stroke="#E0E0E0" strokeLinecap="round" />
      </svg>
    </div>
  );
};

export default StepLine;
